export const MAX_WAIT_MS = 5 * 60_000

export interface PollSchedule {
  steps: ReadonlyArray<readonly [number, number]>
  restMs: number
}

export const pollDelayFor = (
  elapsedMs: number,
  { steps, restMs }: PollSchedule
): number => steps.find(([before]) => elapsedMs < before)?.[1] ?? restMs
